import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Observable } from 'rxjs';
import { AssetIndexTypes } from '../../../../../shared/enums/asset-index-types.enum';
import { FAKE_EXCLUDED_FIELDS } from '../../../../../shared/fields/fake-fields';
import { DepartmentField } from '../../../core/store/departments/department-field.model';
import { FakeField, Field, FieldWithDepartmentField } from '../../../core/store/fields/field.model';
import { PDropdownOption } from '../../../shared/interfaces/p-dropdown-options';
import { FormFieldSortObject, TransactionFormService } from '../../../transactions/services/transaction-form.service';
import { STANDARD_FIELDS } from './../../../../../shared/fields/standard-fields';
import {
    Character,
    Department,
    Disposition,
    ExcludedDisposition,
    Franchise,
    Location,
    Project,
    Set,
    SubDepartment,
    Transaction
} from './../../../core/store/models';

@Component({
    selector: 'ah-transaction-expando-row',
    templateUrl: './transaction-expando-row.component.html',
    styleUrls: ['./transaction-expando-row.component.scss'],
    providers: [TransactionFormService, FileUpload],
    standalone: false
})
export class TransactionExpandoRowComponent implements OnInit {
    @Input() characters: Character[];
    @Input() departments: Department[];
    @Input() dispositions: Disposition[];
    @Input() excludedDispositions: ExcludedDisposition[] = [];
    @Input() franchise: Franchise;
    @Input() indexType?: AssetIndexTypes = AssetIndexTypes.Default;
    @Input() inputFields: Field[] = [];
    @Input() locations: Location[];
    @Input() projects: Project[];
    @Input() sets: Set[];
    @Input() subDepartments: SubDepartment[];
    @Input() transaction: Transaction;

    @Output() matchAssets = new EventEmitter();
    @Output() matchForReview = new EventEmitter();
    @Output() splitAssets = new EventEmitter();

    @ViewChild('photoUpload', { static: false }) photoUpload;

    assetIndexTypes = AssetIndexTypes;
    department: Department;
    excludedFields = FAKE_EXCLUDED_FIELDS;
    excludedDispositionOptions: PDropdownOption[] = [];
    firstFields: FieldWithDepartmentField[] = [];
    hiddenRequiredFields: FieldWithDepartmentField[] = [];
    lastFields: FieldWithDepartmentField[] = [];
    photos = [];
    fieldSortObject: FormFieldSortObject = {
        firstFields: [
            STANDARD_FIELDS.name.canonical_name,
            STANDARD_FIELDS.description.canonical_name,
        ],
        lastFields: []
    };
    standardFields = STANDARD_FIELDS;
    subLocationsForLocation: Observable<PDropdownOption[]>;

    excludedDispositionFields: FieldWithDepartmentField[] =
        [
            {
                departmentField: {} as DepartmentField,
                field: new FakeField(this.excludedFields.excluded_disposition)
            },
            {
                departmentField: {} as DepartmentField,
                field: new FakeField(this.excludedFields.excluded_note)
            }
        ];

    constructor() { }

    ngOnInit() {
        this.department = this.departments.find(dep => dep.id === this.transaction.department_id);
        if (!this.department) {
            console.error('The expando row should not open if a transaction does not have a department');
        }
    }

    splitAsset() {
        this.splitAssets.emit({ data: this.transaction });
    }

    matchExistingAssets() {
        this.matchAssets.emit(this.transaction);
    }

    matchForReviewAssets() {
        if (!this.matchReviewDisabled()) {
            this.matchForReview.emit(this.transaction);
        }
    }

    matchReviewDisabled() {
        if (!this.department.isSosCostumeOrPropsDepartment() && !this.department.isSosSetDepartment()) {
            return true;
        }
        return false;
    }
}
